import getSingleNews from "@services/News/getSingleNews";
import getPartner from "@services/Partner/getPartner";
import getWebinar from "@services/Webinar/getWebinar";

// TODO: complete with new modules, that would need to DELETE UPLOADED files
export const getPreviouslyUploadedUrlMap = {
  partner: getPartner,
  webinar: getWebinar,
  news: getSingleNews,
};
